import { render, staticRenderFns } from "./MdsirFileWidget.vue?vue&type=template&id=e7cea494&"
import script from "./MdsirFileWidget.vue?vue&type=script&lang=js&"
export * from "./MdsirFileWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports